// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__lyCYb","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__4uuNh"};